import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "w-full"
};
const _hoisted_2 = {
  class: "li-head"
};
const _hoisted_3 = {
  key: 0,
  width: "2%",
  class: "pt-2 pr-2 pl-0.2"
};
const _hoisted_4 = {
  width: "5%"
};
const _hoisted_5 = {
  width: "6%"
};
const _hoisted_6 = {
  width: "4%"
};
const _hoisted_7 = {
  class: "block"
};
const _hoisted_8 = {
  width: "7%",
  class: "text-right"
};
const _hoisted_9 = {
  class: "block"
};
const _hoisted_10 = {
  width: "8%",
  class: "text-right"
};
const _hoisted_11 = {
  class: "block"
};
const _hoisted_12 = {
  key: 1,
  width: "4%",
  class: "text-right"
};
const _hoisted_13 = {
  key: 0,
  class: "pr-2"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick", "title"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick", "title"];
const _hoisted_22 = {
  key: 1,
  class: "text-right hover:underline hover:cursor-pointer"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "border-8 border-white"
};
const _hoisted_26 = {
  class: "text-right"
};
const _hoisted_27 = {
  class: "block",
  "data-cy": "subtotal-amount"
};
const _hoisted_28 = {
  key: 0
};
import { useFormatCode } from '@/composables/useFormatCode';
import { useChecked } from '@/composables/useChecked';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import MultipleAttachmentPreview from '@/components/MultipleAttachmentPreview.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { formatCurrency } from '@/services/utils';
import { storeToRefs } from 'pinia';
import { reactive } from 'vue';
import { attachmentsToFileSelector } from '@/utils/attachmentsToFileSelector';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlIcon from '@/components/LlIcon.vue';
const timeUnlockedWarningText = 'This fee was billed on an earlier invoice and its time is still open. Invoicing this entry here marks it billed, so it can no longer be moved to another fee.';

// The warning icon stands in for the '-' placeholder rather than sitting beside it.

export default {
  __name: 'GroupTable',
  props: {
    group: Object
  },
  setup(__props) {
    const props = __props;
    const {
      formatCode
    } = useFormatCode();
    const {
      checked
    } = useChecked();
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      client
    } = invoiceState;
    const {
      features
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const customFlagLabel = companySettings.value.labels?.customFlag || false;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      getIsLocked
    } = useInvoiceState();
    const hasNoAmount = lineItem => lineItem.entries?.every(e => e.billingType === 'nonBillable' || e.billingType === 'fixedFee');
    const grouptTableState = reactive({
      showAttachmentPreview: false
    });

    // Check if the group has expense line items
    const hasExpensesInGroup = group => {
      if (!group || !group.lineItems) return false;

      // Check if the group type is 'expenses'
      if (group.type === 'expenses') return true;

      // Check if any line items in the group have expense properties
      return group.lineItems.some(li => {
        return li && li.expenses && Array.isArray(li.expenses) && li.expenses.length > 0;
      });
    };
    const hasCredit = group => {
      return group.lineItems?.some(lineItem => lineItem?.credit === true);
    };

    // Both checkboxes carry @click.stop in the template: a click reaching the
    // ancestors caused trouble in the expense modal before.
    const checkAll = (group, isChecked) => {
      group.groupChecked = isChecked;
      group.lineItems.forEach(line => {
        line.checked = isChecked;
      });
    };
    const selectLineItem = (group, li, isChecked) => {
      group.groupChecked = false;
      li.checked = isChecked;
    };
    const viewAttachments = lineItem => {
      const {
        expenses
      } = lineItem;
      if (!expenses[0].attachments?.length) return;
      grouptTableState.fileSelector = attachmentsToFileSelector(expenses[0].attachments);
      grouptTableState.showAttachmentPreview = true;
    };
    const editLineItem = (lineItem, changeMatter = false) => {
      invoiceEditorStore.editLineItem(lineItem, changeMatter);
    };
    const hasAttachments = lineItem => {
      if (!lineItem || !lineItem.expenses) return false;
      return lineItem.expenses.some(expense => (expense.attachments || []).length > 0);
    };
    const hideRateForGroup = group => {
      return ['fixedFees', 'expenses'].includes(group.type);
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [grouptTableState.showAttachmentPreview ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: grouptTableState.showAttachmentPreview,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => grouptTableState.showAttachmentPreview = $event),
        width: "800"
      }, {
        default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
          previewSource: grouptTableState.fileSelector,
          onCancel: _cache[0] || (_cache[0] = $event => grouptTableState.showAttachmentPreview = false),
          selectedFileIndex: 0
        }, null, 8, ["previewSource"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), !(__props.group.lineItems.length == 0 || __props.group.hide) ? (_openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("thead", null, [_createElementVNode("tr", _hoisted_2, [!(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createElementBlock("td", _hoisted_3, [_createVNode(LlCheckbox, {
        "model-value": __props.group.groupChecked,
        "aria-label": "Select all line items in this group",
        dense: "",
        class: "no-print",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = isChecked => checkAll(__props.group, isChecked)),
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, null, 8, ["model-value"])])) : _createCommentVNode("", true), _cache[8] || (_cache[8] = _createElementVNode("td", {
        width: "8%"
      }, [_createElementVNode("label", {
        class: "block"
      }, "Date")], -1)), _withDirectives(_createElementVNode("td", _hoisted_4, [...(_cache[5] || (_cache[5] = [_createElementVNode("label", {
        class: "block"
      }, "Initials", -1)]))], 512), [[_vShow, !__props.group?.includeUser]]), _withDirectives(_createElementVNode("td", _hoisted_5, [...(_cache[6] || (_cache[6] = [_createElementVNode("label", {
        class: "block"
      }, "LEDES", -1)]))], 512), [[_vShow, _unref(client)?.codes?.ledes]]), _withDirectives(_createElementVNode("td", _hoisted_6, [_createElementVNode("label", _hoisted_7, _toDisplayString(_unref(customFlagLabel)), 1)], 512), [[_vShow, _unref(customFlagLabel)]]), _cache[9] || (_cache[9] = _createElementVNode("td", {
        width: "{{ 44 + (customFlagLabel ? 0 : 4) + (!group.includeUser ? 0 : 5) + (client?.codes?.ledes ? 0 : 6) + (hasTimeEntryAlready(group) ? 0 : 4)}}%"
      }, [_createElementVNode("label", {
        class: "block"
      }, "Description")], -1)), _createElementVNode("td", _hoisted_8, [_withDirectives(_createElementVNode("label", _hoisted_9, "Hours", 512), [[_vShow, !hasCredit(__props.group)]])]), _createElementVNode("td", _hoisted_10, [_withDirectives(_createElementVNode("label", _hoisted_11, "Rate", 512), [[_vShow, !hasCredit(__props.group)]])]), _cache[10] || (_cache[10] = _createElementVNode("td", {
        width: "10%",
        class: "text-right",
        "data-cy": "line-item-amount"
      }, [_createElementVNode("label", {
        class: "block"
      }, "Amount")], -1)), _unref(features)?.expenseAttachments && hasExpensesInGroup(__props.group) ? (_openBlock(), _createElementBlock("td", _hoisted_12, [...(_cache[7] || (_cache[7] = [_createElementVNode("label", {
        class: "block"
      }, [_createElementVNode("span", {
        class: "mdi mdi-paperclip"
      })], -1)]))])) : _createCommentVNode("", true), _cache[11] || (_cache[11] = _createElementVNode("td", {
        width: "2%"
      }, null, -1))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.group.lineItems, (li, ids) => {
        return _openBlock(), _createElementBlock("tr", {
          class: "hover:bg-[#FCF7DF]",
          key: ids
        }, [!(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createElementBlock("td", _hoisted_13, [_createVNode(LlCheckbox, {
          "model-value": li.checked,
          "aria-label": `Select ${li.description || 'line item'}`,
          dense: "",
          "data-cy": "item-checkbox",
          "onUpdate:modelValue": isChecked => selectLineItem(__props.group, li, isChecked),
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"])])) : _createCommentVNode("", true), _createElementVNode("td", {
          class: "hover:underline hover:cursor-pointer",
          "data-cy": "item-date",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, _toDisplayString(_ctx.formatDate(li.date)), 9, _hoisted_14), _withDirectives(_createElementVNode("td", {
          class: "hover:underline hover:cursor-pointer",
          "data-cy": "item-user",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, [_withDirectives(_createElementVNode("span", null, _toDisplayString(li.account?.initials || li.account?.name), 513), [[_vShow, li.account]])], 8, _hoisted_15), [[_vShow, !__props.group?.includeUser]]), _withDirectives(_createElementVNode("td", {
          "data-cy": "item-ledes",
          class: "hover:underline hover:cursor-pointer",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, [_createElementVNode("label", null, _toDisplayString(_unref(formatCode)(li.codes)), 1)], 8, _hoisted_16), [[_vShow, _unref(client)?.codes?.ledes]]), _withDirectives(_createElementVNode("td", {
          class: "hover:underline hover:cursor-pointer text-center",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, _toDisplayString(_unref(checked)(li.customFlag)), 9, _hoisted_17), [[_vShow, _unref(customFlagLabel)]]), _createElementVNode("td", {
          class: "hover:underline hover:cursor-pointer",
          "data-cy": "item-description",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"]),
          title: li.description
        }, _toDisplayString(li.description), 9, _hoisted_18), _createElementVNode("td", {
          class: "text-right hover:underline hover:cursor-pointer",
          "data-cy": "item-hours",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, _toDisplayString(_ctx.hoursDecimal(li.hours)), 9, _hoisted_19), _createElementVNode("td", {
          class: "text-right hover:underline hover:cursor-pointer",
          "data-cy": "item-rate",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"])
        }, [!hideRateForGroup(__props.group) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
            'align-items-center': li.rate?.amount != 0,
            'pt-1.5 ml-5 d-inline-flex ': li.rate?.amount == 0
          })
        }, [_createTextVNode(_toDisplayString(li.entries?.every(e => e.billingType === 'nonBillable' || e.billingType === 'fixedFee') ? '-' : _unref(formatCurrency)(li.rate?.amount)) + " ", 1), li.rate?.amount == 0 && li.entries?.some(entry => entry.billingType === 'billable') ? (_openBlock(), _createBlock(LlTooltip, {
          key: 0,
          text: 'Entry contains $0 rate'
        }, {
          activator: _withCtx(({
            props
          }) => [_createVNode(_component_v_icon, _mergeProps({
            ref_for: true
          }, props, {
            class: "ml-2 font-xs mb-1",
            color: "warning"
          }), {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" mdi-alert ", -1)]))]),
            _: 1
          }, 16)]),
          _: 1
        })) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 8, _hoisted_20), _createElementVNode("td", {
          class: "text-right hover:underline hover:cursor-pointer",
          "data-cy": "item-amount",
          onClick: _withModifiers($event => editLineItem(li), ["prevent"]),
          title: _unref(formatCurrency)(li.amount)
        }, [!(hasNoAmount(li) && _unref(invoiceState).hasTimeUnlockedWarning(li)) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(hasNoAmount(li) ? '-' : _unref(formatCurrency)(li.amount)), 1)], 64)) : _createCommentVNode("", true), _unref(invoiceState).hasTimeUnlockedWarning(li) ? (_openBlock(), _createBlock(LlTooltip, {
          key: 1,
          text: timeUnlockedWarningText
        }, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlIcon, _mergeProps({
            ref_for: true
          }, props, {
            icon: "mdi-alert",
            class: "ml-2 font-xs mb-1",
            color: "warning",
            "data-cy": "time-unlocked-warning"
          }), null, 16)]),
          _: 1
        })) : _createCommentVNode("", true)], 8, _hoisted_21), _unref(features)?.expenseAttachments && hasExpensesInGroup(__props.group) ? (_openBlock(), _createElementBlock("td", _hoisted_22, [hasAttachments(li) ? (_openBlock(), _createElementBlock("span", _hoisted_23, [_createElementVNode("a", {
          onClick: _withModifiers($event => viewAttachments(li), ["prevent"])
        }, "View", 8, _hoisted_24)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[13] || (_cache[13] = _createElementVNode("td", {
          class: "text-right hover:underline hover:cursor-pointer"
        }, null, -1))]);
      }), 128)), _createElementVNode("tr", _hoisted_25, [_cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1)), _cache[15] || (_cache[15] = _createElementVNode("td", null, [_createElementVNode("label", {
        class: "block text-sm"
      }, "Subtotal")], -1)), _withDirectives(_createElementVNode("td", null, null, 512), [[_vShow, !__props.group?.includeUser]]), _withDirectives(_createElementVNode("td", null, null, 512), [[_vShow, _unref(client)?.codes?.ledes]]), _withDirectives(_createElementVNode("td", null, null, 512), [[_vShow, _unref(customFlagLabel)]]), _cache[16] || (_cache[16] = _createElementVNode("td", null, " ", -1)), _cache[17] || (_cache[17] = _createElementVNode("td", null, " ", -1)), _cache[18] || (_cache[18] = _createElementVNode("td", null, " ", -1)), _createElementVNode("td", _hoisted_26, [_createElementVNode("label", _hoisted_27, _toDisplayString(_unref(formatCurrency)(__props.group.subtotal)), 1)]), _unref(features)?.expenseAttachments && hasExpensesInGroup(__props.group) ? (_openBlock(), _createElementBlock("td", _hoisted_28, "   ")) : _createCommentVNode("", true), _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1))])])])) : _createCommentVNode("", true)], 64);
    };
  }
};